export default __webpack_public_path__ + "static/media/tom-nora-EOLKGKy9u8w-unsplash.2e0e6c66.jpg";